import { inView } from "motion";
import { CountUp } from "countup.js";

const runCounter = (el) => {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    return;
  }

  const useGrouping = el.dataset.useGrouping;
  const decimalPlaces = el.dataset.decimalPlaces;
  const end = el.dataset.end;

  const opts = {
    useGrouping: !!+useGrouping,
  };

  if (decimalPlaces) {
    opts.decimalPlaces = decimalPlaces;
  }

  const counter = new CountUp(el, end, opts);

  counter.start();
};

document.querySelectorAll("[data-component-stats]").forEach((el) => {
  inView(
    el,
    () => {
      const els = el.querySelectorAll("[data-counter]");

      if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        els.forEach((counter) => runCounter(counter));
      }
    },
    {
      margin: "0px 0px -25% 0px",
    },
  );
});
